import script from "./VensoOrderGroupView.vue?vue&type=script&setup=true&lang=ts"
export * from "./VensoOrderGroupView.vue?vue&type=script&setup=true&lang=ts"

import "./VensoOrderGroupView.vue?vue&type=style&index=0&id=f5b87012&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5b87012"]])

export default __exports__